import { AxiosError } from 'axios'

export function getTraceId(err: AxiosError): string | undefined {
  return err.config?.headers?.['x-b3-traceid']
}

export function isAxiosError(err: any): err is AxiosError {
  return Boolean(err?.isAxiosError)
}
